import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {
  AttributeConsistencyControllerService,
  AttributeConsistencyResponse,
  AttributeConsistencyStatus,
  AttributeConsistencyView,
  TenderPhaseType,
  UpsertAttributeConsistencyRequest,
} from '@frontend/shared-api';

@Injectable({providedIn: 'root'})
export class AttributeConsistencyService {
  private readonly consistencyController = inject(AttributeConsistencyControllerService);

  upsert(
    projectId: number,
    evaluationCriteriaId: number,
    subCriteriaId: number,
    attributeId: number,
    request: UpsertAttributeConsistencyRequest,
    phase: TenderPhaseType,
  ): Observable<AttributeConsistencyResponse> {
    const requestParams = {
      projectId: projectId,
      evaluationCriteriaId: evaluationCriteriaId,
      subCriteriaId: subCriteriaId,
      attributeId: attributeId,
      upsertAttributeConsistencyRequest: request,
    };

    switch (phase) {
      case TenderPhaseType.RFP:
        return this.consistencyController.upsertRfpAttributeConsistency(requestParams);
      case TenderPhaseType.RFI:
        return this.consistencyController.upsertRfiAttributeConsistency(requestParams);
      default:
        throw new Error(`Unsupported tender phase type: ${phase}`);
    }
  }

  isUnresolved(consistency: AttributeConsistencyView | undefined): boolean {
    return (
      consistency?.status === AttributeConsistencyStatus.REVIEW_REQUIRED ||
      consistency?.status === AttributeConsistencyStatus.CLARIFICATION_REQUIRED
    );
  }

  countUnresolved(attributes: {consistency?: AttributeConsistencyView}[] | undefined): number {
    return (attributes ?? []).filter((attribute) => this.isUnresolved(attribute.consistency))
      .length;
  }

  countClarificationRequired(
    attributes: {consistency?: AttributeConsistencyView}[] | undefined,
  ): number {
    return (attributes ?? []).filter(
      (attribute) =>
        attribute.consistency?.status === AttributeConsistencyStatus.CLARIFICATION_REQUIRED,
    ).length;
  }
}
